export const renderFloat = (num, precision = 2) => Number.parseFloat(num).toFixed(precision);

const currencyFormatterWithNotation = new Intl.NumberFormat('en-IN', {
  style: 'currency',
  currency: 'INR',
  minimumFractionDigits: 0,
  maximumFractionDigits: 2,
  notation: 'compact',
  compactDisplay: 'long',
});

const currencyFormatterWithoutNotation = new Intl.NumberFormat('en-IN', {
  style: 'currency',
  currency: 'INR',
  minimumFractionDigits: 0,
  maximumFractionDigits: 2,
});

export const formatAmount = (value, formatter = currencyFormatterWithNotation, callback) => {
  if (value === null || value === undefined) {
    return '₹0';
  }

  let result = formatter.format(Number(value));

  return callback ? callback(result) : result;
};

export const baseFormat = (value) => {
  if (value === null || value === undefined) {
    return '₹0';
  }

  const num = Number(value);

  if (num >= -1_00_000 && num <= 1_00_000) {
    return formatAmount(value, currencyFormatterWithoutNotation);
  }

  return formatAmount(value);
};

export const splitFormatAmount = (v) => {
  let splitValue = baseFormat(v).split('.');

  return {
    integer: splitValue[0].slice(1),
    decimal: splitValue[1]?.substring(0, 2),
    notation: splitValue[1]?.substring(2)?.replace('T', 'K'),
    symbol: splitValue[0][0],
  };
};

export const formatPercent = (value) => {
  if (value === null || value === undefined) {
    return '-';
  }
  return `${Number(value).toLocaleString('en-IN', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  })}%`;
};

export const splitDecimal = (value) => {
  const [integer, decimal = '00'] = value.toString().split('.');
  return {
    integer: `₹${(+integer).toLocaleString('en-IN')}`,
    decimal: (decimal + '0').slice(0, 2),
  };
};

export const maskBankAccountNumber = (accountNumber) => {
  if (accountNumber?.length <= 4) {
    return accountNumber;
  }

  const visibleDigits = accountNumber?.slice(-4);
  const maskedDigits = accountNumber?.slice(0, -4)?.replace(/\d/g, '*');

  return maskedDigits + visibleDigits;
};

export const formatDate = (dateString, customOptions = {}) => {
  if (!dateString) {
    return '-';
  }

  const date = new Date(dateString);

  const defaultOptions = { day: 'numeric', month: 'short', year: 'numeric' };

  const options = { ...defaultOptions, ...customOptions };

  const formattedDate = new Intl.DateTimeFormat('en-IN', options).format(date);

  return formattedDate;
};

export const formatAmountWithoutSymbol = (amount, hideDecimals = false) => {
  const numericAmount = Number(amount);

  if (isNaN(numericAmount) || amount === null || amount === undefined) {
    return hideDecimals ? '0' : '0.00 ';
  }

  return `${numericAmount.toLocaleString('en-IN', {
    minimumFractionDigits: hideDecimals ? 0 : 2,
    maximumFractionDigits: hideDecimals ? 0 : 2,
  })}`;
};
